import { KonvaEventObject } from "konva/lib/Node";
import { LineConfig, Line as LineShape } from "konva/lib/shapes/Line";
import { useEffect, useRef, useState } from "react";
import { KonvaNodeEvents, Line } from "react-konva";
import { polygonProps } from "@/entities/planogram";

type BasePolygonProps = LineConfig &
  KonvaNodeEvents & {
    isSelected?: boolean;
    isEmpty?: boolean;
    hoverEnabled?: boolean;
  };

export function BasePolygon({
  isSelected,
  isEmpty,
  points,
  hoverEnabled,
  onPointerEnter,
  onPointerLeave,
  ...props
}: BasePolygonProps) {
  const shapeRef = useRef<LineShape | null>(null);
  const [hovered, setHovered] = useState(false);

  const alpha = isSelected ? 0.35 : 0.25;
  const polygon = polygonProps();

  const fillColor = () => {
    if (isSelected) {
      return polygon.fill().yellow();
    } else if (isEmpty) {
      return polygon.fill(alpha).orange();
    } else return polygon.fill(alpha).blue();
  };

  const strokeColor = () => {
    if (isSelected || hovered) {
      return polygon.stroke().yellow();
    } else if (isEmpty) {
      return polygon.stroke().orange();
    } else return polygon.stroke().blue();
  };

  const strokeWidth = hovered ? polygon.bold() : polygon.thin();

  const handlePointerEnter = (e: KonvaEventObject<PointerEvent>) => {
    if (hoverEnabled) {
      shapeRef.current?.zIndex(100);
      setHovered(true);
    }

    onPointerEnter?.(e);
  };

  const handlePointerLeave = (e: KonvaEventObject<PointerEvent>) => {
    if (!isSelected) {
      shapeRef.current?.zIndex(0);
    }

    setHovered(false);
    onPointerLeave?.(e);
  };

  useEffect(() => {
    if (isSelected) {
      shapeRef.current?.zIndex(100);
    } else {
      shapeRef.current?.zIndex(0);
    }
  }, [isSelected]);

  return (
    <Line
      ref={shapeRef}
      points={points}
      closed
      shadowForStrokeEnabled={false}
      fill={fillColor()}
      stroke={strokeColor()}
      strokeWidth={strokeWidth}
      name="camera-sku-section"
      onPointerEnter={handlePointerEnter}
      onPointerLeave={handlePointerLeave}
      {...props}
    />
  );
}
